import React from 'react';
import SavedMappingsList from './SavedMappingsList';

function MappingsSelectionStep({ mappings, shopSign, client, onMappingSelect, onContinueManual, onDeleteMapping }) {
  // If no mappings are available, allow direct manual configuration.
  if (!mappings || mappings.length === 0) {
    return (
      <div className="text-gray-600">
        Aucun mapping sauvegardé n'a été trouvé pour le couple {shopSign} x {client}.
        <button
          onClick={onContinueManual}
          className="ml-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors duration-200"
        >
          Configurer manuellement
        </button>
      </div>
    );
  }

  return (
    <div className="space-y-6 ">
      <h2 className="text-xl font-semibold text-gray-800 dark:text-white">Mapping sauvegardés</h2>
      <p className="text-gray-600 dark:text-gray-400">
        Veuillez choisir un mapping sauvegardé pour le couple {shopSign} x {client}, ou
        configurer manuellement.
      </p>

      <SavedMappingsList
        mappings={mappings}
        onMappingSelect={onMappingSelect}
        onDeleteMapping={onDeleteMapping}
      />

      <div className="flex justify-between mt-4">
        <button
          onClick={onContinueManual}
          className="px-6 py-2 bg-gray-600 text-white rounded hover:bg-gray-700 transition-colors duration-200"
        >
          Configurer manuellement
        </button>
      </div>
    </div>
  );
}

export default MappingsSelectionStep;